import React from "react"
// import GoogleLogin from "src/libs/GoogleLogin"
import { HCF } from "@macashipo/mlib"
import { HApi, HAuth, HConfig, HUI } from "src/core/helpers"
import { useHistory } from "react-router-dom"
import { setHomepageUrl, cacheMenuAfterLogin } from "src/core/helpers/auth"
import { Path } from "src/modules/app_dnt/constants/path"
import { PATH } from "src/helpers/paths"
import { FcGoogle } from "react-icons/fc"
import { useTranslation } from "react-i18next"
import { useGoogleLogin, GoogleOAuthProvider } from "@react-oauth/google"
import axios from "axios"
import styled from "styled-components"

interface LoginWithGoogleProps {
  onRedirecting?: () => void
}

const LoginWithGoogle = ({ onRedirecting }: LoginWithGoogleProps) => {
  const { t } = useTranslation()
  const history = useHistory()
  const _requestSocialLogin = (SocialId, SocialToken, SocialUsername) => {
    const appName = HCF.getCF("appName")
    if (SocialToken) {
      HApi.apiGeneric({
        method: "POST",
        url: "Account/SocialLogin",
        data: {
          SocialId: SocialId,
          SocialToken: SocialToken,
          SocialUsername: SocialUsername,
          AppName: appName,
        },
      })
        .then(res => {
          if (res?.Data?.Token) {
            sessionStorage.setItem("_menuFetchedByLogin", "1")
            HAuth.authLoginWithRes(res.Data.Token)
            onRedirecting?.()
            HApi.apiGeneric({ method: "POST", url: "Menu/MenuInfo", data: {} })
              .then(menuRes => {
                const menuList = menuRes?.Data?.MenuList || []
                cacheMenuAfterLogin(menuList)
                if (!menuList || menuList.length === 0) {
                  history.push(PATH.MY_PROFILE)
                  return
                }
                const homepageItem = menuList.find(
                  (v: any) => v.IsHomepage === true
                )
                const homepageUrl = homepageItem
                  ? homepageItem.UIUrl ||
                    Path[homepageItem.ScreenCode] ||
                    PATH.HOME
                  : PATH.HOME
                setHomepageUrl(homepageUrl)
                HConfig.goToHome()
              })
              .catch(() => {
                history.push(PATH.MY_PROFILE)
              })
          }
        })
        .catch(error => {})
    }
  }
  const signIn = useGoogleLogin({
    scope:
      "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile",
    onSuccess: tokenResponse => {
      console.warn("tokenResponse:", tokenResponse)
      axios
        .get(
          `https://www.googleapis.com/oauth2/v3/userinfo?access_token=${tokenResponse.access_token}`,
          {}
        )
        .then(res => {
          console.log(res.data)
          if (res.data) {
            const {
              email,
              // name,
              // picture
            } = res.data
            if (tokenResponse) {
              _requestSocialLogin("google", tokenResponse.access_token, email)
            } else {
              HUI.showToastError(t("setting2fa:msg.login_gg_fail"))
            }
          }
        })
    },
  })
  return (
    <Wrap
      className="gg-wrap btn btn-secondary btn-login-gg"
      onClick={() => signIn()}
    >
      {t("login.Login With")}{" "}
      <FcGoogle
        style={{
          width: 20,
          height: 20,
          marginLeft: "0.2rem",
        }}
      />
    </Wrap>
  )
}
const LoginSocialProvider = (props: LoginWithGoogleProps) => {
  return (
    <GoogleOAuthProvider clientId={HCF.getCF("GoogleClientId")}>
      <LoginWithGoogle {...props} />
    </GoogleOAuthProvider>
  )
}

const Wrap = styled.div``
export default LoginSocialProvider
